import $ from '@vaersaagod/tools/Dom';
import Viewport from '@vaersaagod/tools/Viewport';

export default () => {
    const dom = $('body');

    const update = () => {
        const innerHeight = window.innerHeight;
        dom.css({
            minHeight: innerHeight,
            height: innerHeight
        });
    };

    const init = () => {
        Viewport.on('resize', update);
        update();
    };

    const destroy = () => {
        Viewport.off('resize');
    };

    return {
        init,
        destroy
    };
};



// WEBPACK FOOTER //
// ./src/js/components/BodyHeightAdjust.js